import React from 'react';
import { Modal } from '@brighterion/br-ui';
import { GlobalRulesOverviewOverallSchema } from '@brighterion/types/overview';
import { useTranslation } from 'react-i18next';

import styles from './GlobalRulesOverviewModal.css';
import GlobalRulesOverviewOverallForm from '../GlobalRulesOverviewOverallForm';

type GlobalRulesOverviewModalProps = {
    closeModal: () => void;
    isOpen: boolean;
    thresholdData: GlobalRulesOverviewOverallSchema;
};

const GlobalRulesOverviewModal = ({ closeModal, isOpen, thresholdData }: GlobalRulesOverviewModalProps) => {
    const { t } = useTranslation();

    return (
        <Modal
            dataTestId='edit-overview-modal'
            isOpen={isOpen}
            closeModal={closeModal}
            closeOnClickOutside={false}
            scrollLock
            containerClass={styles.editGlobalOverviewModal}
        >
            <Modal.Title id='edit-global-rules-title' title={t('Edit Global Rules Overview')} onClose={closeModal} />
            <GlobalRulesOverviewOverallForm closeModal={closeModal} initialFormValues={thresholdData} />
        </Modal>
    );
};

export default GlobalRulesOverviewModal;
